import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@winamp/ui/components/Breadcrumb/index.js";
import { Container } from "@winamp/ui/components/Container/Container.js";
import { Content } from "@winamp/ui/components/Content/Content.js";
import React from "react";

interface IBreadcrumb {
  label: string;
  to?: string;
  truncate?: boolean;
  key: string;
}

interface ICardLayoutProps {
  breadcrumbs: Array<IBreadcrumb>;
  children: React.ReactNode;
}

export function DetailsPageLayout({ breadcrumbs, children }: ICardLayoutProps) {
  return (
    <Container className="space-y-10">
      <section className="relative w-full">
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs.map((breadcrumb, index) => (
              <React.Fragment key={breadcrumb.key}>
                <BreadcrumbItem truncate={breadcrumb.truncate}>
                  {breadcrumb.to ? (
                    <BreadcrumbLink to={breadcrumb.to}>
                      {breadcrumb.label}
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{breadcrumb.label}</BreadcrumbPage>
                  )}
                </BreadcrumbItem>
                {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </section>
      <Content className="max-md:contents">
        <div className="flex flex-col md:flex-row gap-14 rounded-xl max-md:mt-10">
          {children}
        </div>
      </Content>
    </Container>
  );
}
